import { useAppDispatch, useAppSelector } from "../../hooks/storeHooks"
import { setToEditImages, updateItem } from "../../store/slices/positiveItemSlice";
import { selectPositiveItemToEditImages } from "../../store/selectors/positiveItemSelectors";
import { PositiveItem } from "../../types/positiveItem";
import { updatePositiveItem } from "../../services/positiveItemService";
import { ImagesDialog } from "../Images/ImagesDialog";

export const PositiveItemImagesDialog = () => {
    const dispatch = useAppDispatch();

    const toEditImages = useAppSelector(selectPositiveItemToEditImages);

    if (!toEditImages) {
        return null;
    }

    const onHide = () => {
        dispatch(setToEditImages(undefined));
    };

    const onSave = async (item: PositiveItem) => {
        const updated = await updatePositiveItem(item);

        if (updated) {
            dispatch(updateItem(item));
            onHide();
        }
    }

    return (
        <ImagesDialog item={toEditImages} onSave={onSave} onHide={onHide} />
    )
}